import { createStore } from 'vuex';

import state from './state';
import mutations from './mutations';
import getters from './getters';

import SearchStore from './stores/search/index';
import CheckoutStore from './stores/checkout/index';
import AccountStore from './stores/account/index';
import Base from './stores/base/index';

export default createStore({
  state,
  mutations,
  getters,
  modules: {
    search: SearchStore,
    checkout: CheckoutStore,
    account: AccountStore,
    base: Base
  }
});
